import { useGetUserQuery } from '@/api/piloteer';
import { useAppSelector } from '@/store/hooks';
import { APP_ROUTES } from '@/ui/application-routes';
import { FunctionComponent, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

type EnforceAuthProps = {
  children: React.ReactNode;
};

export const EnforceAuth: FunctionComponent<EnforceAuthProps> = ({
  children,
}) => {
  const navigate = useNavigate();
  const { session, isLoading, error } = useAppSelector((state) => state.auth);

  const user = useGetUserQuery(undefined, { skip: !session });

  useEffect(() => {
    if (isLoading) return;
    if (error) {
      navigate(APP_ROUTES.AUTH.MAIN, { replace: true });
    }
    if (!session) {
      navigate(APP_ROUTES.AUTH.MAIN, { replace: true });
    }
  }, [session, isLoading, error, navigate]);

  if (isLoading || error || !session) {
    return null;
  }

  if (user.isLoading || user.error || !user.data) return null;

  return <>{children}</>;
};
